"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/Store/RangePick/index.vue"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _timeConflit = _interopRequireDefault(require("../mixins/timeConflit"));
var _index2 = require("../statics/index");
var _excluded = ["planTaskType"]; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** components */
/** services */
/** mixins */
/** statics */
// 类型 ，计划、任务，由前端自行维护
var _default2 = exports.default = {
  components: {
    RangePick: _index.default
  },
  mixins: [_dialog.default, _timeConflit.default],
  props: {
    // 左侧table选中的date具体信息
    actDateinfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 其他计划类型
    planTypeOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 所有下拉options配置
    /**
     * optConfig.visitPurposeOptions: [], // 拜访目的select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var defaultForm = {
      /** form */
      planTaskType: '',
      // 任务类型
      customerName: '',
      // 门店名称
      PCD: [],
      // 省市区 不传后端
      cusRegion: '',
      // 省label
      cusRegionCode: '',
      // 省
      cusCity: '',
      // 市label
      cusCityCode: '',
      // 市
      cusDistrict: '',
      // 区label
      cusDistrictCode: '',
      // 区
      customerAddress: '',
      // 门店地址
      planTaskStartTime: '',
      // 开始时间
      planTaskEndTime: '',
      // 结束时间
      visitPurpose1: '',
      // 拜访目的1
      visitPurpose2: '',
      // 拜访目的2
      remark: '' // 简要说明
    };
    return {
      PT_STATUS_PLAN: _index2.PT_STATUS_PLAN,
      // 计划
      PT_STATUS_TASK: _index2.PT_STATUS_TASK,
      // 任务
      actualPlanTaskFlag: '',
      // Y:实际任务；N:计划任务
      formLabelWidth: '120px',
      // isShowModel: false, // from mixins
      dialogStatus: 'create',
      /** form group */
      pickerOptions: {
        start: '00:00',
        end: '23:30',
        step: '00:30'
      },
      regionProps: {
        expandTrigger: 'hover'
      },
      form: Object.assign({}, defaultForm),
      initForm: Object.assign({}, defaultForm),
      rules: {
        validateIpt: [{
          required: true,
          trigger: ['blur'],
          message: this.$t('errorValid.empty')
        }],
        validateChoose: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }]
      },
      /** other */
      canSubmit: true
    };
  },
  computed: {
    // 弹窗标题
    dialogTitle: function dialogTitle() {
      return "".concat(this.dialogStatus === 'edit' ? this.$t('common.edit') : this.$t('common.add')).concat(this.$t('doubleWeekPlan.title.somethingElse'), "\uFF1A").concat(this.actDateinfo.planTaskDateStr || '');
    },
    startOptions: function startOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        maxTime: this.form.planTaskEndTime
      });
    },
    endOptions: function endOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        minTime: this.form.planTaskStartTime
      });
    },
    // 计划类型为 潜在客户
    isTypeSpec: function isTypeSpec() {
      return ['A10'].indexOf(this.form.planTaskType) >= 0;
    },
    // 按类型（计划｜任务）过滤选项 潜在客户
    formatPlanTypeOptions: function formatPlanTypeOptions() {
      if (this.actualPlanTaskFlag === this.PT_STATUS_TASK) {
        return this.planTypeOptions.filter(function (i) {
          return i.code !== 'A10';
        });
      } else {
        return this.planTypeOptions;
      }
    }
  },
  methods: {
    // open dialog init
    init: function init(type) {
      // 没有选中日期不能操作
      if (!this.actDateinfo.planTaskDate) {
        return false;
      }
      this.isShowModel = true;
      this.actualPlanTaskFlag = type;
      console.log(333, this.actualPlanTaskFlag);
    },
    /** save event */saveItem: function saveItem() {
      var _this = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        // 重复触发
        if (!_this.canSubmit) {
          return false;
        }
        _this.canSubmit = false;
        var _this$form = _this.form,
          planTaskType = _this$form.planTaskType,
          other = (0, _objectWithoutProperties2.default)(_this$form, _excluded);
        delete other.PCD;
        var params = {
          actualPlanTaskFlag: _this.actualPlanTaskFlag,
          planTaskDate: _this.actDateinfo.planTaskDate || '',
          planTaskType: planTaskType,
          detailList: [(0, _objectSpread2.default)({}, other)]
        };
        (0, _doubleWeekPlan.savePlanTask)(params).then(function () {
          _this.$message({
            message: _this.$t('common.saveSuccess'),
            type: 'success'
          });
          _this.$emit('refresh');
          _this.isShowModel = false;
        }).catch(function (err) {
          // 如果是时间冲突了，则弹出冲突弹窗
          var _params$detailList = params.detailList,
            detailList = _params$detailList === void 0 ? [] : _params$detailList,
            actualPlanTaskFlag = params.actualPlanTaskFlag,
            planTaskDate = params.planTaskDate;
          var conflitParams = {
            actualPlanTaskFlag: actualPlanTaskFlag,
            planTaskDate: planTaskDate,
            timeList: detailList.map(function (i) {
              return {
                startTime: i.planTaskStartTime,
                endTime: i.planTaskEndTime
              };
            })
          };
          _this.timeConflitHandle(err.errorInfos, conflitParams);
        }).finally(function () {
          _this.canSubmit = true;
        });
      });
    }
  }
};